"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationCard = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var SummaryCard_1 = require("../../../../../../shared/core/components/SummaryCard");
var copy_1 = require("../../../../copy");
var MigrationCard = function (_a) {
    var transactions = _a.transactions, isDualFuel = _a.isDualFuel, hasLegacyStatements = _a.hasLegacyStatements;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, core_1.useComponents)(), Ul = _b.Ul, Li = _b.Li;
    var migrationText = transactions.length === 1 || !isDualFuel ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Copy, { copyKey: "migrationTextSingleTransaction", values: {
                date: transactions[0].date
                    ? (0, date_fns_1.format)(transactions[0].date, 'd MMMM yyyy')
                    : 'Invalid date',
            }, props: {
                amount: transactions[0].netCredit.pounds,
            } }),
        isDualFuel ? (react_1.default.createElement(Copy, { copyKey: "migrationDual" })) : (react_1.default.createElement(Copy, { copyKey: "migrationSingle" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Copy, { copyKey: "migrationTextMultipleTransaction" }),
        react_1.default.createElement(Ul, null, transactions.map(function (_a, index) {
            var date = _a.date, netCredit = _a.netCredit;
            return (react_1.default.createElement(Li, { key: "transactionDetails-".concat(index) },
                react_1.default.createElement(Copy, { copyKey: "migrationTextTransactionDetails", values: {
                        date: date ? (0, date_fns_1.format)(date, 'd MMMM yyyy') : 'Invalid date',
                    }, props: {
                        amount: netCredit.pounds,
                    } })));
        })),
        react_1.default.createElement(Copy, { copyKey: "migrationMultiple" })));
    return (react_1.default.createElement(SummaryCard_1.SummaryCard, { "data-testid": "migration-summary-card", heading: react_1.default.createElement(Copy, { copyKey: "migrationTitle" }), icon: "checkInCircleFilled" },
        migrationText,
        hasLegacyStatements ? react_1.default.createElement(Copy, { copyKey: "hasLegacyStatement" }) : null));
};
exports.MigrationCard = MigrationCard;
